const API_PATH = {
  DELIVERY_LOCATION: {
    DELIVERY_LOCATION: '/delivery',
  },
  DOWNLOAD: {
    S3: '/millsheet/download-s3',
  },
  OPTIONS: {
    ORGANIZATION_BASE: '/organization-base/options',
    STEEL_MAKER: '/millsheet/steel-maker',
    BUSINESS_TYPE: '/millsheet/business-type',
    STEEL_TYPE: '/master/steel-type-options',
    STEEL_CATEGORY: '/master/steel-category-options',
    STEEL_CATEGORY_TYPE: '/master/steel-category-type-options',
    CUSTOMER: '/millsheet/customer',
    CUSTOMER1: '/millsheet/customer1',
    CUSTOMER2: '/millsheet/customer2',
    CUSTOMER3: '/millsheet/customer3',
    LANGUAGE: '/master/language',
    TRADING_COMPANY: '/master/trading-company-options',
  },
  ORGANIZATION_BASE: {
    ORGANIZATION_BASE: '/organization-base',
  },
  ORGANIZATION: {
    ORGANIZATION: '/organization',
    ORGANIZATION_WITH_USE_FLAG: '/organization/with-use-flag',
  },
  INFORMATION: {
    INFORMATION: '/information',
    INFORMATION_BY_TRADING_COMPANY_CODE: '/information/by-trading-company-code',
    INFORMATION_NO_TRADING_COMPANY_CODE: '/information/no-trading-company-code',
    INFORMATION_TRADING_COMPANY: '/information/trading-company',
    INFORMATION_NO_TRADING_COMPANY: '/information/no-trading-company',
  },
  NEWS: {
    NEWS: '/trading-company-news',
    NEWS_BY_TRADING_COMPANY_CODE: '/trading-company-news/by-trading-company-code',
    NEWS_TRADING_COMPANY: '/trading-company-news/trading-company',
  },
  USER: {
    USER: '/user',
    USER_BY_ORGANIZATION: '/user/organization',
    ADMIN_POWERUSER: '/user/approvers',
  },
  OWNINFO: {
    OWNINFO: '/user/own-info',
    ORGANIZATION_USER: '/organization-user',
  },
  SESSION: {
    RESET_PASSWORD: '/user/resetPassword',
  }
};

export default API_PATH;
